export const BASEURL = "https://dashboard.pluralcode.com/api";
// export const BASEURL = "http://127.0.0.1:8000/api";

export const PLACEHOLDER = "/placeholder.png";

export const WEBINAR_REGISTRATION =
  "https://pluralcode.com/workshops/erp-workshop/register";



// Blogs
export const BLOGS = BASEURL + "/blogs";
export const CONTACT = BASEURL + "/contact_enquiries/new";
export const LEAD_MAGNET = BASEURL + "/lm";
export const DOWNLOAD_LEAD_MAGNET = BASEURL + "/lm/download";
export const NEWSLETTER = BASEURL + "/newsletter/subscribe";
export const SOMETHING_WENT_WRONG = "Something went wrong";

// API Wrappers
export const returnOrThrow = async (resJSON) => {
  let result;
  const status = resJSON.status;
  if (status === 404 || status >= 500) {
    throw `${SOMETHING_WENT_WRONG}!`;
  } else if (status === 401) {
    throw "sessionTimeout";
  }
  try {
    result = await resJSON.json();
  } catch (err) {
    result = { error: SOMETHING_WENT_WRONG };
  }
  if (status !== 200) {
    throw result.error;
  }
  return result;
};

const getHeadersObject = () => {
  return {
    "Content-Type": "application/json",
    // "ngrok-skip-browser-warning": "69420",
  };
};

export const getToken = () => {
  const token = localStorage.getItem("Token");
  return token;
};
const getHeadersFileObject = () => {
  const token = getToken();
  return {
    Authorization: `${token}`,
    // "Content-Type": "multipart/form-data",
  };
};
export const getWrapper = async (url, body = {}) => {
  const headers = getHeadersObject();
  const resJSON = await fetch(url, {
    method: "GET",
    headers,
  });
  return resJSON;
};

export const postWrapper = async (url, body, fileUpload = false) => {
  const headers = fileUpload ? getHeadersFileObject() : getHeadersObject();
  const resJSON = await fetch(url, {
    method: "POST",
    body: fileUpload ? body : JSON.stringify(body),
    headers,
  });
  return resJSON;
};


export const postNewsletterSubscription = async (data) => {
  const resJSON = await postWrapper(NEWSLETTER, data);
  const result = await returnOrThrow(resJSON);
  return result;
};

export const getBlogs = async (type = "") => {
  const resJSON = await getWrapper(`${BLOGS}?type=${type}`);
  const result = await returnOrThrow(resJSON);
  return result;
};


export const getBlogDetail = async (slug) => {
  const resJSON = await getWrapper(`${BLOGS}/${slug}`);
  const result = await returnOrThrow(resJSON);
  return result;
};



export const getLeadMagnet = async (slug, utmParams = {}) => {
   const queryString = new URLSearchParams(utmParams).toString();
  const resJSON = await getWrapper(`${LEAD_MAGNET}/${slug}?${queryString}`);
  const result = await returnOrThrow(resJSON);
  return result;
};




export const postLeadMagnetResponseForm = async (data) => {
  const resJSON = await postWrapper(
    `${LEAD_MAGNET}/${data.slug}/responses/create`,
    data
  );
  const result = await returnOrThrow(resJSON);
  return result;
};
